import { useMemo } from 'react';

const useCurrencyFormatter = (currency?: string): Intl.NumberFormat => {
  return useMemo(() => {
    if (!currency) {
      return Intl.NumberFormat('nl-BE');
    }

    return Intl.NumberFormat('nl-BE', {
      style: 'currency',
      currency,
    });
  }, [currency]);
};

export default useCurrencyFormatter;
